var map = {
	"./bayarind.svg": "3614",
	"./bayarind2.svg": "6d02",
	"./bill-rp-check.svg": "3e8f",
	"./billing.svg": "4d24",
	"./contactless-payment-circle.svg": "480d",
	"./dashboard.svg": "69123",
	"./disbursement.svg": "79f8",
	"./group.svg": "b846",
	"./integration.svg": "af5b",
	"./merchant-lead.svg": "05e0",
	"./merchant-network.svg": "860c",
	"./payment-gateway.svg": "7446",
	"./receipt.svg": "3183",
	"./report.svg": "adf8",
	"./setting.svg": "b45a",
	"./transfer-file.svg": "6cf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c333";